import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Modal from 'react-modal';
import { API_BASE_URL } from '../utils/apiConfig';
import { useUserContext } from '../context/user_context';
//Pdf imports
import { FiDownload, FiPrinter } from 'react-icons/fi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Mypdf from '../components/PDF/Mypdf';

const GroupSubscriberWiseDataList = ({ items }) => {

    const { groupId } = useParams();
    const [selectedSubscriber, setSelectedSubscriber] = useState(null);
    const [subscriberData, setSubscriberData] = useState(null);
    const { isLoggedIn, user, isLoading, setIsLoading } = useUserContext();

    const [image, setImage] = useState('');
    const [previewImage, setPreviewImage] = useState('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
    const [altText, setAltText] = useState('');
    const [error, setError] = useState(null);

    // to show pop upon mouse over on the maount
    // to show pop upon mouse over on the maount
    const [popupData, setPopupData] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

    // for PDF generator
    const [pdfData, setPdfData] = useState(null);
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const [companyName, setCompanyName] = useState(null);

    const userCompany = user?.results?.userCompany;




    const handleMouseEnter = (event, payments) => {
        const rect = event.target.getBoundingClientRect();
        setPopupData(payments);

        setPopupPosition({
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX + rect.width
        });

    };

    const handleMouseLeave = () => {
        setPopupData(null);
    }


    // Function to generate file name with today's date
    const generateFileName = () => {
        const today = new Date();
        const date = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        return `SubscriberGroupWise_Receivable_${year}-${month}-${date}.pdf`;
    };

    const fetchCompanyLogoUrl = async (logoKey) => {


        // setLoading(true);
        setError(null);

        try {
            // Fetch the signed URL for the company logo using a GET request
            const response = await fetch(`${API_BASE_URL}/get-signed-url?key=${encodeURIComponent(logoKey)}`, {
                method: 'GET',
                headers: {
                    // Include any headers if needed
                    // 'Authorization': 'Bearer YourAccessToken',
                },
            });

            if (response.ok) {
                const responseBody = await response.json();
                const signedUrl = responseBody.results;

                // setFormData({
                //     companyLogo: signedUrl,
                // })
                setPreviewImage(
                    signedUrl
                )


            } else {
                // Handle error if needed based on the HTTP status code
                console.error(`Failed to fetch signed URL for company logo: ${logoKey}`);
            }
        } catch (error) {
            // Handle fetch error
            console.error('Error fetching signed URL for company logo:', error);
            setError('Error fetching signed URL for company logo');
        } finally {
            //   setLoading(false);
        }
    };
    useEffect(() => {
        if (user.results.userCompany.length > 0) {

            if (user.results.userCompany[0].name) {
                setCompanyName(user.results.userCompany[0].name);
                fetchCompanyLogoUrl(user.results.userCompany[0].logo);
            }
        }
    }, [user]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Check if selectedSubscriber exists before constructing the URL
                if (selectedSubscriber) {
                    const apiUrl = `${API_BASE_URL}/groups/${groupId}/customer-due/${selectedSubscriber.subscriber_id}`;

                    const response = await fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${user?.results?.token}`, // Include the Bearer token
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.ok) {
                        const data = await response.json();

                        setSubscriberData(data.results.groupsWiseSubscriberResult);

                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Check if selectedSubscriber is not null before fetching data
        if (selectedSubscriber) {
            fetchData();
        }
    }, [selectedSubscriber, groupId, user]);


    // Log subscriberData when it changes
    useEffect(() => {
        console.log('SubscriberData updated:', subscriberData);
    }, [subscriberData]);

    const openModal = (subscriber) => {
        setSelectedSubscriber(subscriber);
    };

    const closeModal = () => {
        setSelectedSubscriber(null);
        setSubscriberData(null); // Clear data when modal is closed
    };

    useEffect(() => {
        if (selectedSubscriber && selectedSubscriber.user_image) {
            fetchCompanyLogoUrl(selectedSubscriber.user_image);
        }
    }, [selectedSubscriber]);

    const handleGeneratePDF = () => {
        let formattedData;  
        formattedData = items.map(item => ({
            name: item.name,
            total_supposed_to_pay: item.total_supposed_to_pay,
            total_paid_amount: item.total_paid_amount,
            total_outstanding_balance: item.total_outstanding_balance
        }));
        
        setPdfData(formattedData); // ✅ Moved inside the function
    };
    
    
    const handleGeneratePDFforindividualsubscriber = () => {
        let formattedData;  
        formattedData = subscriberData.map(item => ({
            auct_date: item.auct_date,
            total_supposed_to_pay: item.total_supposed_to_pay,
            total_paid_amount: item.total_paid_amount,
            total_outstanding_balance: item.total_outstanding_balance
        }));
        
        setPdfData(formattedData); // ✅ Moved inside the function
    };
    



    return (
        <div>
            {
                pdfData ? (
                    <PDFDownloadLink document={<Mypdf tableData={pdfData}
                        
                        tableHeaders={[
                            { title: "Subscriber Name", value: "name" },
                            { title: "Total", value: "total_supposed_to_pay" },
                            { title: "Paid", value: "total_paid_amount" },
                            { title: "Due", value: "total_outstanding_balance" },
                        ]}
                        heading="Group SubcriberWise Receivable" // Pass heading here
                      
                        companyData={userCompany}
                       
                       
                    />} fileName={generateFileName()}>
                        {({ loading }) => (loading ? 'Loading document...' : <button onClick={() => {
                            setTimeout(() => {
                                setPdfData(null); // Reset pdfData after download
                            }, 500);
                        }}><FiDownload /> Download PDF</button>)}
                    </PDFDownloadLink>
                ) : (
                    <button onClick={handleGeneratePDF}><FiDownload /> Generate PDF</button>
                )
            }
            <div className='subcriber-list'>
                <article className='subcriber-header'>
                    <p>Subscriber</p>
                    <p>Total Amount</p>
                    <p>Paid</p>
                    <p>Outstanding</p>
                </article>
                {items?.map((item, index) => {
                    const { name, subscriber_id, total_supposed_to_pay, total_paid_amount, total_outstanding_balance, user_image,user_image_from_s3, firstname } = item;

                    const formattedTotalPay = total_supposed_to_pay ?? 0;
                    const formattedPaid = total_paid_amount ?? 0;
                    const formattedOutstanding = total_outstanding_balance ?? 0;



                    return (
                        <div key={subscriber_id} className='subcriber-link' onClick={() => openModal(item)}>
                            <article className='subcriber-item'>
                                <p>{name}</p>
                                <p>{formattedTotalPay}</p>
                                <p>{formattedPaid}</p>
                                <p>{formattedOutstanding}</p>
                            </article>
                        </div>
                    );
                })}

                {/* Modal */}
                <Modal
                    isOpen={!!selectedSubscriber}
                    onRequestClose={closeModal}
                    contentLabel="Subscriber Details"
                >
                    {selectedSubscriber && (
                        <div style={{ position: "relative" }}>
                            <button style={{ width: "30px", height: "30px", border: "none", position: "absolute", top: "-4px", right: "-4px", borderRadius: "4px" }} onClick={closeModal}>X</button>
                            <p>
                               
                                    <img
                                     style={{
                                        width: "150px",
                                        height: "150px",
                                        objectFit: "cover",
                                        borderRadius: "4px", // optional: slightly rounded corners
                                        margin: "0 0 20px",
                                    }}
                                    src={selectedSubscriber.user_image_from_s3}
                                    alt={selectedSubscriber.name}
                                />
                                
                            </p>
                            <h2 style={{ fontSize: "30px" }}>{selectedSubscriber.name}'s Details</h2>
                            <p>Total Amount: {selectedSubscriber.total_supposed_to_pay}</p>
                            <p>Paid: {selectedSubscriber.total_paid_amount}</p>
                            <p>Outstanding: {selectedSubscriber.total_outstanding_balance}</p>

                            {/* Display the list of items for the selected subscriber */}
                            {
                                pdfData ? (
                                    <PDFDownloadLink document={<Mypdf tableData={pdfData}
                                       
                                        tableHeaders={[
                                            { title: "Auction Date", value: "auct_date" },
                                            { title: "Total", value: "total_supposed_to_pay" },
                                            { title: "Paid", value: "total_paid_amount" },
                                            { title: "Due", value: "total_outstanding_balance" },
                                        ]}
                                        heading="Subcriber Auction Wise Receivable" // Pass heading here
                                        
                                        companyData={userCompany}
                                     
                                    />} fileName={generateFileName()}>
                                        {({ loading }) => (loading ? 'Loading document...' : <button onClick={() => {
                                            setTimeout(() => {
                                                setPdfData(null); // Reset pdfData after download
                                            }, 500);
                                        }}><FiDownload /> Download PDF</button>)}
                                    </PDFDownloadLink>
                                ) : (
                                    <button onClick={ handleGeneratePDFforindividualsubscriber}><FiDownload /> Generate PDF</button>
                                )
                            }
                            {subscriberData ? (
                                <ul style={{ marginTop: "16px" }}>
                                    <li>
                                        <span style={{ width: "140px" }}><strong>Auction</strong></span>
                                        <span style={{ width: "180px", textAlign: "center" }}><strong>Pay</strong></span>
                                        <span style={{ width: "160px", textAlign: "center" }}><strong> Paid </strong></span>
                                        <span style={{ width: "220px", textAlign: "center" }}><strong> Outstanding Balance</strong></span>
                                    </li>
                                    {subscriberData.map((item, index) => (
                                        <li key={index}>
                                            {/* Display item details as needed */}
                                            <span style={{ width: "140px" }}>{item.auct_date}</span>
                                            <span style={{ width: "180px", textAlign: "center" }}>{item.total_supposed_to_pay}</span>
                                            <span
                                                style={{ width: "160px", textAlign: "center" }}
                                                className="receivable-paid"
                                                onMouseEnter={(event) => handleMouseEnter(event, item.payments)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                {item.total_paid_amount}

                                            </span>
                                            <span style={{ width: "220px", textAlign: "center" }}>{item.total_outstanding_balance}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No items available</p>
                            )}
                        </div>
                    )}

                    {popupData && (
                        <div
                            className="popup"
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                backgroundColor: 'white',
                                border: '1px solid #ddd',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                padding: '10px',
                                zIndex: 1000,
                            }}
                        >
                            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                                {popupData.map((receipt) => (
                                    <li key={receipt.id} style={{ margin: '5px 0' }}>
                                        Date: {new Date(receipt.created_at).toLocaleDateString()} - Payment: {receipt.payment_amount} {receipt.payment_method}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal>

            </div>
        </div>
    );
};

export default GroupSubscriberWiseDataList;
